
import Vue from "vue";
import FileUpload from "@/components/FileUpload";
import PhotoAnnounceHistory from "@/components/PhotoAnnounceHistory";

export default Vue.extend({
  name: "PhotoAnnounce",
  components: {
    FileUpload,
    PhotoAnnounceHistory
  },
  methods: {
    onHistoryChanged() {
      const history = this.$refs.history as Vue & { fetch?: () => void };
      if (history && history.fetch) {
        history.fetch();
      }
    }
  }
});
